import { createSlice } from '@reduxjs/toolkit';
import { _setEmployeeDetails } from './employeeDetailsAction';

export const employeeDetailsSlice = createSlice({
  name: 'delta/employeeDetails',
  initialState: null,
  reducers: {
    setEmployeeDetails: _setEmployeeDetails,
    resetEmployeeDetails: () => null,
  },
});

export const { setEmployeeDetails, resetEmployeeDetails } =
  employeeDetailsSlice.actions;

export default employeeDetailsSlice.reducer;
